module.exports = __webpack_public_path__ + "img/site-default.c3f576be.png";